export default {
  title: 'Ordreportal',
  form: {
    username: {
      placeholder: 'Brugernavn',
    },
    password: {
      placeholder: 'Adgangskode',
    },
  },
  buttons: {
    submit: 'Log ind',
  },
  toasts: {
    auth_token_invalid: 'Det angivne godkendelsestoken er ugyldigt. Log ind med dine loginoplysninger',
    credentials_invalid: 'Forkert brugernavn eller adgangskode',
  },
};
